Object.defineProperty(exports,"__esModule",{value:true});exports.makeCreateContainerFunction=exports.combineContainerMixins=undefined;var _flow2=require("lodash/flow");var _flow3=_interopRequireDefault(_flow2);var _includes2=require("lodash/includes");var _includes3=_interopRequireDefault(_includes2);var _forOwn2=require("lodash/forOwn");var _forOwn3=_interopRequireDefault(_forOwn2);var _groupBy2=require("lodash/groupBy");var _groupBy3=_interopRequireDefault(_groupBy2);var _toPairs2=require("lodash/toPairs");var _toPairs3=_interopRequireDefault(_toPairs2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==="function"?Symbol.iterator:"@@iterator"](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==="function"?Symbol.iterator:"@@iterator")in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();
var _victoryCore=require("victory-core");

var _victoryVoronoiContainer=require("./victory-voronoi-container");
var _victoryZoomContainer=require("./victory-zoom-container");
var _victorySelectionContainer=require("./victory-selection-container");
var _victoryBrushContainer=require("./victory-brush-container");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var ensureArray=function ensureArray(thing){
if(!thing){
return[];
}else if(!Array.isArray(thing)){
return[thing];
}else{
return thing;
}
};

var combineEventHandlers=function combineEventHandlers(eventHandlersArray){


return eventHandlersArray.reduce(function(localHandlers,finalHandlers){
(0,_forOwn3.default)(localHandlers,function(localHandler,eventName){
var existingHandler=finalHandlers[eventName];
if(existingHandler){

finalHandlers[eventName]=function combinedHandler(){

var existingMutations=ensureArray(existingHandler.apply(undefined,arguments));
var localMutations=ensureArray(localHandler.apply(undefined,arguments));
return existingMutations.concat(localMutations);
};
}else{
finalHandlers[eventName]=localHandler;
}
});
return finalHandlers;
});
};

var combineDefaultEvents=function combineDefaultEvents(defaultEvents){


var eventsByTarget=(0,_groupBy3.default)(defaultEvents,"target");
return(0,_toPairs3.default)(eventsByTarget).map(
function(_ref){var _ref2=_slicedToArray(_ref,2),target=_ref2[0],eventsArray=_ref2[1];
return{
target:target,
eventHandlers:combineEventHandlers(eventsArray.map(function(event){return event.eventHandlers;}))};


});

};

var combineContainerMixins=exports.combineContainerMixins=function combineContainerMixins(mixins,Container){var _class,_temp;





var Classes=mixins.map(function(mixin){return mixin(Container);});
var instances=Classes.map(function(Class){return new Class();});
var NaiveCombinedContainer=(0,_flow3.default)(mixins)(Container);

return _temp=_class=function(_NaiveCombinedContain){_inherits(VictoryCombinedContainer,_NaiveCombinedContain);function VictoryCombinedContainer(){_classCallCheck(this,VictoryCombinedContainer);return _possibleConstructorReturn(this,(VictoryCombinedContainer.__proto__||Object.getPrototypeOf(VictoryCombinedContainer)).apply(this,arguments));}_createClass(VictoryCombinedContainer,[{key:"getChildren",value:function getChildren(





















props){
return instances.reduce(
function(children,instance){return instance.getChildren(_extends({},props,{children:children}));},
props.children);

}}]);return VictoryCombinedContainer;}(NaiveCombinedContainer),_class.displayName="CustomVictoryContainer",_class.propTypes=Classes.reduce(function(propTypes,Class){return _extends({},propTypes,Class.propTypes);},{}),_class.defaultProps=Classes.reduce(function(defaultProps,Class){return _extends({},defaultProps,Class.defaultProps);},{}),_class.defaultEvents=combineDefaultEvents(Classes.reduce(function(defaultEvents,Class){return[].concat(_toConsumableArray(defaultEvents),_toConsumableArray(Class.defaultEvents));},[])),_temp;

};

var checkBehaviorName=function checkBehaviorName(behavior,behaviors){
if(behavior&&!(0,_includes3.default)(behaviors,behavior)){
_victoryCore.Log.warn("\""+
behavior+"\" is not a valid behavior. Choose from ["+behaviors.join(", ")+"].");

}
};

var makeCreateContainerFunction=exports.makeCreateContainerFunction=function makeCreateContainerFunction(mixinMap,Container){return function(behaviorA,behaviorB){
var behaviors=Object.keys(mixinMap);

checkBehaviorName(behaviorA,behaviors);
checkBehaviorName(behaviorB,behaviors);

if(arguments.length<=2?0:arguments.length-2){
_victoryCore.Log.warn("too many arguments given to createContainer (maximum accepted: 2).");
}

var firstMixins=mixinMap[behaviorA];
var secondMixins=mixinMap[behaviorB]||[];

if(!firstMixins){
return Container;
}

return combineContainerMixins([].concat(_toConsumableArray(firstMixins),_toConsumableArray(secondMixins)),Container);
};};exports.default=

makeCreateContainerFunction({
zoom:[_victoryZoomContainer.zoomContainerMixin],
voronoi:[_victoryVoronoiContainer.voronoiContainerMixin],
selection:[_victorySelectionContainer.selectionContainerMixin],
brush:[_victoryBrushContainer.brushContainerMixin]},_victoryCore.VictoryContainer);


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/create-container.js
// module id = 1346
// module chunks = 0